import { render, staticRenderFns } from "./ContractRequestCompensatory.vue?vue&type=template&id=84fc4494&scoped=true"
import script from "./ContractRequestCompensatory.vue?vue&type=script&lang=js"
export * from "./ContractRequestCompensatory.vue?vue&type=script&lang=js"
import style0 from "./ContractRequestCompensatory.vue?vue&type=style&index=0&id=84fc4494&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84fc4494",
  null
  
)

export default component.exports